import { InfoOutlined } from '@mui/icons-material';
import { Breadcrumbs, breadcrumbsClasses, Stack, styled } from '@mui/material';

export const InfoStyled = styled(InfoOutlined)(({ theme }) => ({
  verticalAlign: 'middle',
  display: 'inline-flex',
  marginTop: -4,
  marginLeft: 2,
  color: theme.palette.text.secondary,
}));

export const BreadcrumbsStyled = styled(Breadcrumbs)(({ theme }) => ({
  [`& .${breadcrumbsClasses.ol}`]: {
    gap: theme.spacing(1),
  },
  [`& .${breadcrumbsClasses.separator}`]: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export const StackStyled = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));
